import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { GET_PARSERS } from "../graphql/Queries/ParserQuery";
import { DELETE_PARSER } from "../graphql/Mutations/ParserMutation";
import { useTranslation } from "react-i18next";

export const Parsers = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();
  const { t } = useTranslation();
  const { data } = useQuery(GET_PARSERS, {
    fetchPolicy: "no-cache",
  });
  const [removeMetro] = useMutation(DELETE_PARSER);

  useEffect(() => {
    if (data) {
      setItems(data.parser);
    }
  }, [data]);

  const remove = (id) => {
    removeMetro({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteParser);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"Парсеры"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              {Number(data?.estateError) > 0 && (
                <div style={{ position: "absolute", color: "#f1556c" }}>
                  {t("К-во объявлений с ошибками перевода")}:{" "}
                  {data?.estateError}
                </div>
              )}
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "name", label: "Название" },
                  { key: "link", label: "Ссылка" },
                  {
                    key: "enable",
                    label: "Состояние",
                    callback: (value) => {
                      return Number(value) === 1 ? t("Включен") : t("Отключен");
                    },
                  },
                  { key: "queue", label: "К-во в очереди" },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
